import { FALLBACK_GST_RATE_PCT } from '@lib/gst';
import { getGstRate } from '@services/wallet.service';
import { useQuery } from '@tanstack/react-query';

/**
 * The GST rate the server will actually charge, for pre-checkout previews.
 *
 * Server-owned so a config change can't leave the UI quoting a payable that
 * differs from the Razorpay sheet. It is effectively static, so it is cached
 * for the session; if the request fails the preview falls back to the
 * documented default rather than showing a bare pre-tax figure.
 */
export function useGstRate(): number {
  const { data } = useQuery({
    queryKey: ['wallet', 'gst-rate'],
    queryFn: getGstRate,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
  const rate = data?.gst_rate_pct;
  return typeof rate === 'number' && Number.isFinite(rate) && rate >= 0
    ? rate
    : FALLBACK_GST_RATE_PCT;
}
